import {
  forwardRef,
  HStack,
  Text,
} from '@chakra-ui/react';

export interface AccountTextProps {
  account: { number: string; name: string };
}

export const AccountText = forwardRef<AccountTextProps, 'div'>((props, ref) => {
  const {
    account: { number, name },
  } = props;

  //   return (
  //     <Box ref={ref}>
  //       <Text paddingRight={'4'}>{number}</Text>
  //       <Text as="cite">{name}</Text>
  //     </Box>
  //   );

  return (
    <HStack>
      <Text>{number}</Text>
      <Text as="cite">{name}</Text>
    </HStack>
  );
});
